module.exports = __webpack_public_path__ + "static/img/icon3 1.cbacecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon3 1.png
// module id = Yz1y
// module chunks = 1